import React from "react";
import "../styles/CasosExito.scss";

export const CasosExito = () => {
  return (
    <div className="containerCasosExito d-flex justify-content-start align-items-center flex-column">
      <div className="d-flex justify-content-center align-items-center flex-column titleCasosExito text-center">
        <br/>
        <span className="titleCasos mt-4">
          Historias de éxito que inspiran
        </span>
        <span className="subtitleCasos fs-6">
          Conoce cómo Asesorarte Seguros ha transformado la vida de personas que decidieron emprender en el mundo financiero, alcanzando independencia económica y un propósito real ayudando a proteger familias mexicanas.
        </span>
      </div>

      <div className="resenasContainerManin mt-5 mb-5">
        <div className="resena" id="resena1">
          <span className="titleResena mt-3">Norma Carranza Ruiz</span><br/>
          <div className="containerDialogImg">
            <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          </div>
          <div className="containerOpinion mt-3">
            <span className="textOpinion">
              Norma decidió dejar su trabajo de oficina para iniciar su carrera como asesora financiera. Gracias a la formación, mentoría y acompañamiento de Asesorarte en Seguros, en menos de un año duplicó sus ingresos y ahora lidera un equipo que ayuda a más de 50 familias a estar protegidas y seguras.
            </span>
          </div>
        </div>

        <div className="resena" id="resena2">
          <span className="titleResena mt-3">Cristhian Cruz Pineda</span><br/>
          <div className="containerDialogImg">
            <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          </div>
          <div className="containerOpinion mt-3">
            <span className="textOpinion">
              Cristhian era emprendedor independiente y buscaba una fuente de ingresos estable. Se unió a Asesorarte en Seguros y descubrió una carrera con propósito. Hoy disfruta de libertad financiera, reconocimiento y la satisfacción de ayudar a las familias de su comunidad a construir un futuro más seguro.
            </span>
          </div>
        </div>

        <div className="resena" id="resena3">
          <span className="titleResena mt-3">Karla</span><br/>
          <div className="containerDialogImg">
            <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          </div>
          <div className="containerOpinion mt-3">
            <span className="textOpinion">
              Karla siempre tuvo vocación de servicio. En Asesorarte en Seguros encontró un espacio donde pudo combinar su pasión por ayudar con el crecimiento económico. Hoy es mentora de nuevos agentes y ha logrado alcanzar metas que antes veía imposibles, disfrutando de tiempo, propósito y estabilidad.
            </span>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center align-items-center flex-column titleCasosExito text-center fs-5">
        <span className="subtitleCasos">
          🌟 Ellos ya transformaron su vida con Asesorarte en Seguros 🌟
          <br/><br/><span className="fs-2 prox"><b>¡Tú puedes ser el próximo!</b></span> 
        </span>
      </div>
    </div>
  );
};

export default CasosExito;
